import React,{useEffect,useState} from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminAdmissionControl.css";

const AdminAdmissionControl=()=>{   

const [settings,setSettings]=useState([]);

/* ================= LOAD SETTINGS ================= */

const loadSettings=()=>{

axios.get("/api/registration-settings")
.then(res=>{
setSettings(res.data);
})
.catch(err=>{
console.log(err);
});

};

useEffect(()=>{
loadSettings();
},[]);


/* ================= MAKE ACTIVE ================= */

const makeActive=(id)=>{

axios.put(`/api/registration-settings/activate/${id}`)
.then(res=>{

alert("Admission Status Updated");

loadSettings();

})
.catch(err=>{
console.log(err);
alert("Update Failed");
});

};


/* ================= UI ================= */

return(

<div className="container mt-4">

<h4>Admission Control Panel</h4>

<div className="table-responsive">

<table className="table table-bordered">

<thead className="table-dark">

<tr>
<th>ID</th>
<th>Status</th>
<th>Message</th>
<th>Image</th>
<th>Action</th>
</tr>

</thead>

<tbody>

{settings.map(item=>(

<tr key={item.id}>

<td>{item.id}</td>

<td>

<span className={`badge ${item.active ? "bg-success":"bg-secondary"}`}>
{item.admission_status}
</span>

</td>

<td>{item.admission_message}</td>

<td>

{item.left_panel_image && (

<img
src={`${BASE_URL}/uploads/${item.left_panel_image}`}
alt="panel"
width="120"
/>

)}

</td>

<td>

{item.active ? (

<button className="btn btn-success" disabled>
Active
</button>

) : (

<button
className="btn btn-outline-primary"
onClick={()=>makeActive(item.id)}
>
Make Active
</button>

)}

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

);

};

export default AdminAdmissionControl;